import React from "react";
import "./calendar.scss";
import ServiceCalendar from "component/ServiceCalendar/ServiceCalendar";
import { DateFormater } from "functions/dateTimeFormat";
import { FormattedMessage, useIntl } from "react-intl";
import { LabelLangString } from "component/LabelLang/label-lang";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import HtmlView from "component/htmlView/html-view";
import { useSelector } from "react-redux";
import InnerHeader from "component/shared/innerheader/InnerHeader";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import MainDepartment from "component/shared/main-department/MainDepartment";
// import fetch from "../../auth/FetchInterceptor.js";
// import { useNavigate } from "react-router-dom";
import CalItem from "./components/calItem";
import ReactGA from "react-ga4";

export default function Calendar() {
  const intl = useIntl();

  // const navigate = useNavigate();

  const currentLocale = useSelector(({ theme }) => theme.locale);
  const userInfo = useSelector(({ auth }) => auth);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: "/calendar",
      title: "Calendar Page",
    });
  }, []);

  const date = new Date();

  const [openList, setOpenList] = React.useState(false);
  const [currentDate, setCurrentDate] = React.useState(null);
  const [currentMonth, setCurrentMonth] = React.useState(date.getMonth() + 1);
  const [currentYear, setCurrentYear] = React.useState(date.getFullYear());

  const monthCal = useSWR({
    url: END_POINTS.API_MONTH_CALENDAR,
    params: {
      Year: currentYear,
      Month: currentMonth,
    },
  });

  const periodicsLookup = useSWR({
    url: END_POINTS.PERIODICS,
  });

  const userSubscriptions = useSWR({
    url: userInfo?.token ? END_POINTS.USER_PUBLICATION_SUBSCRIPTIONS : null,
  });
  const monthCalData =
    monthCal.error ||
    monthCal.isLoading ||
    monthCal.data === undefined ||
    monthCal.data.data === undefined
      ? []
      : monthCal.data.data;

  const userPublicationSubscriptions =
    userSubscriptions.error ||
    userSubscriptions.isLoading ||
    userSubscriptions.data === undefined ||
    userSubscriptions.data.data === undefined
      ? []
      : userSubscriptions.data.data;

  const dayCal = useSWR({
    url: END_POINTS.API_DAY_CALENDAR,
    params: {
      Date: currentDate?.format("MM-DD-YYYY"),
    },
  });
  const dayCalData =
    dayCal.error ||
    dayCal.isLoading ||
    dayCal.data === undefined ||
    dayCal.data.data === undefined
      ? []
      : dayCal.data.data;
  const colors = monthCalData.map((x) => x.calendarTypeId);

  function getPeriodic(id) {
    var periodicData = periodicsLookup?.data?.data;
    if (periodicData != null) {
      var found = periodicData.find((x) => x.id == id);
      return found ? found : [];
    }
    return [];
  }

  const getServices = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS}/${END_POINTS.CALENDER_DEPARTMENT_ID}`,
  });

  const getDepartment = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS_DEPARTMENT}=${END_POINTS.CALENDER_DEPARTMENT_ID}`,
  });

  return (
    <ContentLoading
      isLoading={getDepartment.isLoading || getServices.isLoading}
    >
      <div className="calendar">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "calender" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "browse-calender" })}
          route={"../servicestools"}
        />
        <div className="container py-5">
          <div className="row">
            <div className="col-12 col-lg-8">
              {/* <div>{JSON.stringify(monthCalData)}</div> */}
              <div className="calendar-container">
                {/*<img 
                              loading="lazy"
                  className="img-fluid"
                  src={process.env.PUBLIC_URL + "/image/Calendar.png"}
                  alt="calender"
                />*/}
                <ServiceCalendar
                  data={monthCalData}
                  currentDate={currentDate}
                  setCurrentDate={setCurrentDate}
                  currentMonth={currentMonth}
                  setCurrentMonth={setCurrentMonth}
                  currentYear={currentYear}
                  setCurrentYear={setCurrentYear}
                  colors={colors}
                />
                {/*currentDate?.format("LL")*/}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="calendar-coll">
                {currentDate == undefined ? (
                  <div className="calendar-coll-headr">
                    <h6>
                      {" "}
                      <FormattedMessage id="choose-day" />{" "}
                    </h6>
                  </div>
                ) : (
                  <div className="calendar-coll-headr">
                    <h6>
                      {" "}
                      <DateFormater value={currentDate?.format("LL")} /> (
                      {dayCalData?.length} <FormattedMessage id="events" />){" "}
                    </h6>
                  </div>
                )}
                {currentDate == undefined ? (
                  <></>
                ) : (
                  <>
                    {dayCalData?.map(
                      (
                        {
                          calendarTypeId,
                          date,
                          event,
                          internationalDay,
                          publication,
                        },
                        index
                      ) => (
                        <CalItem
                          key={index}
                          calendarTypeId={calendarTypeId}
                          date={date}
                          event={event}
                          internationalDay={internationalDay}
                          publication={publication}
                          openList={openList}
                          setOpenList={setOpenList}
                          index={index}
                          currentLocale={currentLocale}
                          getPeriodic={getPeriodic}
                          userInfo={userInfo}
                          userPublicationSubscriptions={userPublicationSubscriptions}
                          dayCalData={dayCalData}
                        />
                      )
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 col-lg-8">
              <div className="calnd-info">
                <ul>
                  <li>
                    <span></span>{" "}
                    <h6>
                      <FormattedMessage id="publication-release" />
                    </h6>
                  </li>
                  <li>
                    <span className="brwn"></span>{" "}
                    <h6>
                      <FormattedMessage id="international-days" />
                    </h6>
                  </li>
                  <li>
                    <span className="red"></span>{" "}
                    <h6>
                      <FormattedMessage id="events-conferences" />
                    </h6>
                  </li>
                </ul>
                {getServices?.data?.data?.content !== null &&
                getServices?.data?.data?.content !== undefined ? (
                  <HtmlView
                    html={LabelLangString({
                      id: "content",
                      currentLocale: currentLocale,
                      defaultValue: getServices?.data?.data?.content,
                      translations:
                        getServices?.data?.data?.serviceAndToolTranslation,
                    })}
                  />
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
                {/* <p>
                  <FormattedMessage id="publication-dates" />
                </p>
                <p>
                  <FormattedMessage id="last-update" />{" "}
                  <DateFormater value={Date.now()} />
                </p>
                <p>
                  <FormattedMessage id="in-case" />
                </p> */}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <MainDepartment getDepartment={getDepartment} />
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}
